module.exports = __webpack_public_path__ + "img/jackass.d0381331.webp";